import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';

import { ILogo } from '../../ts/services/LogoService';
import { NavStyles } from '../layout/NavigationStyles';

export class Logo extends React.Component<Logo.Props, any> {

  static element = React.createFactory(Logo);

  static marginTop = 11;
  static marginRight = 48;
  static marginBottom = 12;
  static marginLeft = 18;

  public static totalMargin = Logo.marginLeft + Logo.marginRight;

  public render() {
    const logo = this.props.logo;
    const widthWithBorder = logo.width + 1; // + 1 for border
    const heightWithBorder = logo.height + 1; // + 1 border

    const style: React.CSSProperties = {
      width: widthWithBorder,
      height: heightWithBorder,
      backgroundImage: 'url(' + logo.image + ')',
      display: 'inline-block',
      marginLeft: Logo.marginLeft,
      marginRight: Logo.marginRight,
      marginTop: Logo.marginTop,
      marginBottom: Logo.marginBottom,

      // This is used with the ' ' text content to prevent a strange issue with
      // links with no text content. Without text content, the logo was somehow expanding
      // the containing div height by 3px. Text decoration 'none' is used to prevent an
      // underline hover style on the link.
      whiteSpace: 'pre',
      textDecoration: 'none',
      backgroundSize: `${widthWithBorder}px ${heightWithBorder}px`,
      backgroundRepeat: 'no-repeat',
      ...logo.styleOverrides
    };

    if (this.props.disableLink) {
      return this.renderSpan(style);
    } else {
      return this.renderLink(style);
    }
  }

  private renderSpan(style: React.CSSProperties) {
    return (
      <span
        onClick={this.props.onClick}
        style={style}
        title={this.props.logo.title}
        className={NavStyles.LogoFocus}
      >

      </span>
    );
  }

  private renderLink(style: React.CSSProperties) {
    const href = this.props.logo.href || this.props.siteUrls.projectsUrl();
    return (
      <a
        onClick={this.props.onClick}
        style={style}
        title={this.props.logo.title}
        className={NavStyles.LogoFocus}
        tabIndex={0}
        href={href}
        data-tb-test-id="top-bar-logo-link"
      >

      </a>
    );
  }
}

export module Logo {

  export interface Props {
    siteUrls: SiteUrls;
    logo: ILogo;
    onClick?: () => void;
    disableLink?: boolean;
  }

}
